export const REQ_ERR_MSG = "This field is required";
export const PATTERN_ERR_MSG = "Incorrect Data!!!";
export const placeholder = "Enter";
export const USA_PHONE_PATTERN_ERR_MSG = "Incorrect Data :- e.g. 000-000-0000";
export const CONTACT_PHONE_PATTERN_ERR_MSG = "Invalid phone number. Use Format 000-000-0000";
